import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";

import "./AssignAssessmentOverview.css";

function DyslexiaScreenerResultsOverview() {
  const location = useLocation();
  const navigate = useNavigate();

  const student = location.state?.student || null;
  const classDetails = location.state?.classDetails?.classDetails || null;
  const className = location.state?.className || classDetails?.name || null;
  const schoolid = location.state?.schoolid?.schoolid || null;
  const teacherid = location.state?.teacherid?.teacherid || null;
  const countryId = location.state?.countryId?.countryId || null;

  const completedAssessment = student?.assessments?.find((a) => a.completed);
  const dateCompleted = completedAssessment?.completed_at
    ? new Date(completedAssessment.completed_at).toLocaleDateString("en-IE", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    : "NYS";
  const score =
    completedAssessment?.score != null
      ? `${completedAssessment.score}%`
      : "NYS";

  return (
    <Container fluid style={{ paddingLeft: 0 }}>
      <Row className="row-position">
        <Col>
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              padding: "30px",
              marginTop: "20px",
            }}
          >
            <h2 style={{ color: "#333", marginBottom: "4px" }}>
              Dyslexia Screener Results
            </h2>
            {className && (
              <p style={{ color: "#555", fontSize: "1rem", marginBottom: "0" }}>
                Class: <strong>{className}</strong>
              </p>
            )}
            {student && (
              <p style={{ color: "#555", fontSize: "1rem", marginBottom: "0" }}>
                Student: <strong>{student.name}</strong>
              </p>
            )}
            <hr style={{ borderColor: "#ddd", marginBottom: "20px" }} />

            {/* Summary Card */}
            <Row className="mb-4">
              <Col md={4}>
                <div
                  style={{
                    border: "2px solid #ddd",
                    borderRadius: "8px",
                    padding: "20px",
                    textAlign: "center",
                  }}
                >
                  <p style={{ color: "#888", marginBottom: "4px", fontSize: "0.9rem" }}>
                    Date Completed
                  </p>
                  <p style={{ fontWeight: "600", fontSize: "1.2rem", color: "#333", margin: 0 }}>
                    {dateCompleted}
                  </p>
                </div>
              </Col>
              <Col md={4}>
                <div
                  style={{
                    border: "2px solid #ddd",
                    borderRadius: "8px",
                    padding: "20px",
                    textAlign: "center",
                  }}
                >
                  <p style={{ color: "#888", marginBottom: "4px", fontSize: "0.9rem" }}>
                    Overall Score
                  </p>
                  <p style={{ fontWeight: "600", fontSize: "1.2rem", color: "#8E44AD", margin: 0 }}>
                    {score}
                  </p>
                </div>
              </Col>
              <Col md={4}>
                <div
                  style={{
                    border: "2px solid #ddd",
                    borderRadius: "8px",
                    padding: "20px",
                    textAlign: "center",
                  }}
                >
                  <p style={{ color: "#888", marginBottom: "4px", fontSize: "0.9rem" }}>
                    Screener
                  </p>
                  <p style={{ fontWeight: "600", fontSize: "1.2rem", color: "#333", margin: 0 }}>
                    {completedAssessment?.name || "N/A"}
                  </p>
                </div>
              </Col>
            </Row>

            {/* Placeholder for detailed results */}
            <div
              style={{
                border: "2px dashed #ddd",
                borderRadius: "8px",
                padding: "40px",
                textAlign: "center",
                color: "#aaa",
              }}
            >
              <p style={{ fontSize: "1.1rem", marginBottom: "8px" }}>
                Detailed results and audio playback will appear here.
              </p>
              <p style={{ fontSize: "0.9rem" }}>
                This section is under construction.
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default DyslexiaScreenerResultsOverview;
